var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "align-items-center flex-nowrap",
      class: _vm.loaderPosition === "left" ? "ml-2" : "mr-2",
    },
    [
      _vm.showLoader("left") ? _c("inline-loader") : _vm._e(),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "div",
          { staticClass: "form-group-material" },
          [
            _c("select2", {
              ref: "select",
              attrs: {
                id: _vm.id,
                data: _vm.classifications,
                value: _vm.value,
                disabled: _vm.disabled,
                name: _vm.id,
                options: _vm.options,
                "format-data": _vm.formatData,
              },
              on: { change: _vm.handleChange },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.showLoader("right") ? _c("inline-loader") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }